<template>
  <div class="layout">
    <HeaderBook :doc="article" />
    <div class="layout__wrapper">
      <section class="article-single background-section">
        <div class="container article-single__content control-container">
          <BackLink class="article-single__backlink" />
          <Sidebar :doc="article" />
          <slot> </slot>
          <PrevNext :article="article" />
          <ArticleThread :article="article" />
        </div>
      </section>
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
import Sidebar from '@/app/components/doc/reading/Sidebar.vue'
import HeaderBook from '@/app/components/doc/Header.vue'
import BackLink from '@/app/components/BackLink.vue'
import Footer from '@/app/components/Footer.vue'

import PrevNext from './PrevNext.vue'
import ArticleThread from './Thread.vue'

import { ArticleView } from '@/models/doc.article'

defineProps<{
  article: ArticleView
}>()
</script>

<style lang="scss" scoped>
.article-single {
  &__backlink {
    margin-bottom: 24px;

    @media only screen and (max-width: $w-tablet-s) {
      display: none;
    }
  }
}
</style>
